import React from 'react';
import ChatMessage from './ChatMessage';
import { ScrollArea } from '@/components/ui/scroll-area';

export interface Message {
  id: string;
  role: 'user' | 'assistant';
  content: string;
  timestamp: Date;
  imageUrl?: string;
  generatedImages?: string[];
  imagePrompt?: string;
}

interface ChatContainerProps {
  messages: Message[];
  isGenerating: boolean;
}

const ChatContainer: React.FC<ChatContainerProps> = ({ messages, isGenerating }) => {
  return (
    <ScrollArea className="flex-1 w-full overflow-hidden">
      {messages.length > 0 ? (
        <div className="divide-y divide-border/40">
          {messages.map((message) => (
            <ChatMessage 
              key={message.id}
              role={message.role}
              content={message.content}
              timestamp={message.timestamp}
              imageUrl={message.imageUrl}
              generatedImages={message.generatedImages}
              imagePrompt={message.imagePrompt}
            />
          ))}
          
          {isGenerating && (
            <div className="py-4 px-8 animate-pulse-slow">
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 rounded-full bg-neon-purple"></div>
                <div className="w-2 h-2 rounded-full bg-neon-pink"></div>
                <div className="w-2 h-2 rounded-full bg-neon-orange"></div>
              </div>
            </div>
          )}
        </div>
      ) : (
        <div className="flex items-center justify-center h-full text-muted-foreground">
          <p className="text-sm">No messages to display</p>
        </div>
      )}
    </ScrollArea>
  );
};

export default ChatContainer;
